import type { VaccinationRecord } from '../types'

/**
 * 取得疫苗紀錄的有效日期（統一入口）
 * 優先順序：actualDate → customPlannedDate → plannedDate
 */
export function getEffectiveDate(record: VaccinationRecord): string {
  return record.actualDate ?? record.customPlannedDate ?? record.plannedDate
}

/**
 * 取得疫苗紀錄的顯示用預計日期
 * 優先順序：customPlannedDate → plannedDate
 */
export function getDisplayPlannedDate(record: VaccinationRecord): string {
  return record.customPlannedDate ?? record.plannedDate
}

/**
 * 是否有使用者自訂日期
 */
export function hasCustomPlannedDate(record: VaccinationRecord): boolean {
  return !!record.customPlannedDate
}
